import { render, staticRenderFns } from "./UserInfoModal.vue?vue&type=template&id=cdef0048"
import script from "./UserInfoModal.vue?vue&type=script&lang=js"
export * from "./UserInfoModal.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./UserInfoModal.vue?vue&type=style&index=1&id=cdef0048&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports